/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser'
import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'
import * as Sentry from '@sentry/browser'
import { environment } from '@environments/environment'

Sentry.init({
  dsn: environment.sentryDsn,
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
})

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err))
